import { Component, OnInit } from '@angular/core';
import { ServicioImprimirAdmisionService, ParametrosImprimirAdmisionEntity, EntidadEmpresarial } from 'src/app/services/servicio-imprimir-admision.service';
import { ActivatedRoute } from '@angular/router';
import { ServicioAltaVoluntariaService, ObjectRequest, AltaVoluntariaEntity } from 'src/app/services/servicio-alta-voluntaria.service';
import { EmpresaEntity } from 'src/app/interfaces/empresa';
import { FiltroEntity } from 'src/app/interfaces/filtro-entity';

@Component({
  selector: 'app-reporte-alta-voluntaria',
  templateUrl: './reporte-alta-voluntaria.component.html',
  styleUrls: ['./reporte-alta-voluntaria.component.css']
})
export class ReporteAltaVoluntariaComponent implements OnInit {
  private parametrosUrl: ParametrosImprimirAdmisionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: '',
    uncoAdmision: ''
  };

  public errorDataReporte = false;
  public loading = true;
  public error = false;
  public fechaImpresion: Date = new Date();
  public uncoMotivo: string;
  public uncoEmpresa: string;
  public listEmpresas: EmpresaEntity[] = [];
  public listFiltro: FiltroEntity[] = [];
  public dataEntidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: ''
  };
  public dataReporte: AltaVoluntariaEntity = {
    consecutivoAdmision: '',
    numeroIdentificacion: '',
    tipoDocumento: '',
    sexo: '',
    sede: '',
    paciente: '',
    puntoAtencion: '',
    direccion: '',
    telefono: '',
    fechaAdmision: '',
    descripcionCorta: '',
    motivoAltaVoluntaria: ''
  };

  constructor(
    private servicioAdmision: ServicioImprimirAdmisionService,
    private servicioAlta: ServicioAltaVoluntariaService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.parametrosUrl.codigoBaseDatos = params.codigoBaseDatos;
      this.parametrosUrl.uncoSede = params.uncoSede;
      this.parametrosUrl.uncoLogin = params.uncoLogin;
      this.parametrosUrl.uncoAdmision = params.uncoAdmision;
    });
  }

  ngOnInit() {
    this.getInfoEntidadEmpresarial();
    this.getFilterEmpresas();
  }

  public getEmpresa( uncoEmpresa: string ) {
    if ( uncoEmpresa !== undefined && uncoEmpresa !== '-1') {
      this.uncoEmpresa = uncoEmpresa;
      this.getFilterMotivoAltaVoluntaria(uncoEmpresa);
    } else {
      this.listFiltro = [];
    }
  }

  public getMotivo( uncoMotivo: string ) {
    this.uncoMotivo = uncoMotivo;
    if ( uncoMotivo !== undefined && uncoMotivo !== '-1') {
      this.getDataAltaVoluntaria(this.uncoEmpresa, uncoMotivo);
    }
  }

  public getGenerar() {
    if ( this.uncoMotivo !== undefined && this.uncoMotivo !== '-1' && this.uncoEmpresa !== undefined && this.uncoEmpresa !== '-1' ) {
      this.getDataAltaVoluntaria(this.uncoEmpresa, this.uncoMotivo);
    }
  }

  public getPrint() {
    window.print();
  }

  /* Consumo de los servicios */

  private async getFilterEmpresas() {
    const response = await this.servicioAlta.getFiltroEmpresasAltaVoluntaria(this.parametrosUrl.codigoBaseDatos, this.parametrosUrl.uncoAdmision);

    response.subscribe( (data: any) => {
      if ( data !== null && data !== [] ) {
        this.listEmpresas = data;
      }
      // console.log(data);
    }, error => {
      this.error = true;
      console.log(error);
    });
  }

  private async getFilterMotivoAltaVoluntaria( uncoEmpresa: string ) {
    const response = await this.servicioAlta.getFiltroAltaVoluntaria(this.parametrosUrl.codigoBaseDatos, this.parametrosUrl.uncoAdmision, uncoEmpresa);

    response.subscribe( (data: any) => {
      if ( data !== null && data !== [] ) {
        this.listFiltro = data;
      }
      // console.log(data);
    }, error => {
      this.error = true;
      console.log(error);
    });
  }

  private async getDataAltaVoluntaria( uncoEmpresa: string, uncoMotivo: string ) {
    const param: ObjectRequest = {
      codigoBaseDatos: this.parametrosUrl.codigoBaseDatos,
      uncoAdmision: this.parametrosUrl.uncoAdmision,
      uncoEmpresa: uncoEmpresa,
      uncoMotivoAlta: uncoMotivo
    };

    const response = await this.servicioAlta.getDataAltaVoluntaria(param);

    response.subscribe( (data: any) => {
      if ( data !== null && data !== [] ) {
        this.dataReporte = data;
        this.loading = false;
      }
      // console.log(data);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getInfoEntidadEmpresarial() {
    const response = await this.servicioAdmision.getEntidadEmpresarial(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataEntidadEmpresarial = data[0];
      }
      // console.log(this.dataEntidadEmpresarial);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

}
